module.exports = __webpack_public_path__ + "img/CM0000_rabbit.529b2e6a.png";